import {
  createRenderer,
  createPrimitiveControlRenderer,
} from '@web-config-app/entity-form';
import { TextareaControl } from '../components/controls-primitive/textarea-control/textarea-control.component';
import { TextInputControl } from '../components/controls-primitive/text-input-control/text-input-control.component';
import { DateInputControl } from '../components/controls-primitive/date-input-control/date-input-control.component';
import { DateTimeInputControl } from '../components/controls-primitive/datetime-input-control/datetime-input-control.component';
import { DataPointInputControl } from '../components/controls-primitive/data-point-input-control/data-point-input-control.component';
import { SelectInputControl } from '../components/controls-primitive/select-input-control/select-input-control.component';
import { NumberInputControl } from '../components/controls-primitive/number-input-control/number-input-control.component';
import { IntegerInputControl } from '../components/controls-primitive/integer-input-control/integer-input-control.component';
import { BooleanInputControl } from '../components/controls-primitive/boolean-input-control/boolean-input-control.component';
import { AssetUriControl } from '../components/controls-primitive/asset-uri-control/asset-uri-control.component';
import { ObjectControl } from '../components/controls-complex/object-control/object-control.component';
import { ObjectCard } from '../components/controls-complex/object-card/object-card.component';
import { ConditionalActionControl } from '../components/controls-complex/conditional-action-control/conditional-action-control.component';
import { CheckboxGroupControl } from '../components/controls-complex/checkbox-group-control/checkbox-group-control.component';
import { ArrayOfPrimitiveObjectsControl } from '../components/controls-complex/array-of-primitive-objects-control/array-of-primitive-objects-control.component';
import { ArrayPrimitiveControl } from '../components/controls-complex/array-primitive-control/array-primitive-control.component';
import { ArrayOfComplexObjectsControl } from '../components/controls-complex/array-of-complex-objects-control/array-of-complex-objects-control.component';
import { EntitySelectControl } from '../components/controls-complex/entity-select-control/entity-select-control.component';
import { ArrayEntityReferenceControl } from '../components/controls-complex/array-entity-reference-control/array-entity-reference-control.component';
import { SelectableDiscriminatorCombinatorControl } from '../components/controls-complex/selectable-discriminator-combinator-control/selectable-discriminator-combinator-control.component';
import { ConstantDiscriminatorCombinatorControl } from '../components/controls-complex/constant-discriminator-combinator-control/constant-discriminator-combinator-control.component';
import { RichTextInputControl } from '../components/controls-primitive/rich-text-input-control/rich-text-input-control.component';
import { ArrayJsonLogicControl } from '../components/controls-complex/array-of-json-logic-control/array-of-json-logic-control.component';
import { DataSourceEnumControl } from '../components/controls-primitive/data-source-enum-control/data-source-enum-control.component';
import { JsonInputControl } from '../components/controls-primitive/json-input-control/json-input-control.component';
import { CodeEditorControl } from '../components/controls-primitive/code-editor-control/code-editor-control.component';
import { ArrayTextareaControl } from '../components/controls-primitive/array-textarea-control/array-textarea-control.component';
import { GeneratedIdControl } from '../components/controls-primitive/generated-id-control/generated-id-control.component';
import { AssetFileControl } from '../components/controls-primitive/asset-inputs/image-file-control/asset-file-control.component';
import { MediaReferenceControl } from '../components/controls-complex/entity-select-control/media-reference-control/media-reference-control.component';
import {
  isTextInputControl,
  isDateInputControl,
  isDateTimeInputControl,
  isNumberInputControl,
  isIntegerInputControl,
  isBooleanInputControl,
  isAssetUriControl,
  isObjectDispatchControl,
  isArrayPrimitiveDispatchControl,
  isSelectInputControl,
  isArrayObjectPrimitiveDispatchControl,
  isArrayObjectComplexDispatchControl,
  isArrayEntityReferenceControl,
  isEntityReferenceInjectedControl,
  isEntityReferenceStringControl,
  isRichTextInputControl,
  isCombinatorObjectInputControl,
  isCombinatorOneOfArrayInputControl,
  isCombinatorArrayItemPageControl,
  isObjectCard,
  isConditionalActionControl,
  isTextareaControl,
  isDataPointInputControl,
  isJsonLogicArrayControl,
  isDataSourceEnumControl,
  isJsonInputControl,
  isCodeEditorControl,
  isArrayTextareaControl,
  isGeneratedIdControl,
  isAssetFileControl,
  isMediaReferenceInputControl,
  isCheckboxGroupControl,
} from '../testers/control-testers';

/**
 * Primitive Input Controls
 */

export const textInputControlRenderer = createPrimitiveControlRenderer(
  isTextInputControl,
  TextInputControl,
);

export const textareaInputControlRenderer = createPrimitiveControlRenderer(
  isTextareaControl,
  TextareaControl,
);

export const arrayTextareaInputControlRenderer = createPrimitiveControlRenderer(
  isArrayTextareaControl,
  ArrayTextareaControl,
);

export const dateInputControlRenderer = createPrimitiveControlRenderer(
  isDateInputControl,
  DateInputControl,
);

export const dateTimeInputControlRenderer = createPrimitiveControlRenderer(
  isDateTimeInputControl,
  DateTimeInputControl,
);

export const selectInputControlRenderer = createPrimitiveControlRenderer(
  isSelectInputControl,
  SelectInputControl,
);

export const numberInputControlRenderer = createPrimitiveControlRenderer(
  isNumberInputControl,
  NumberInputControl,
);

export const integerInputControlRenderer = createPrimitiveControlRenderer(
  isIntegerInputControl,
  IntegerInputControl,
);

export const booleanInputControlRenderer = createPrimitiveControlRenderer(
  isBooleanInputControl,
  BooleanInputControl,
);

export const richTextInputControlRenderer = createPrimitiveControlRenderer(
  isRichTextInputControl,
  RichTextInputControl,
);

export const jsonInputControlRenderer = createPrimitiveControlRenderer(
  isJsonInputControl,
  JsonInputControl,
);

export const codeEditorControlRenderer = createPrimitiveControlRenderer(
  isCodeEditorControl,
  CodeEditorControl,
);

export const assetUriControlRenderer = createPrimitiveControlRenderer(
  isAssetUriControl,
  AssetUriControl,
);

export const mediaReferenceInputControlRenderer =
  createPrimitiveControlRenderer(
    isMediaReferenceInputControl,
    MediaReferenceControl,
  );

export const dataPointControlRenderer = createPrimitiveControlRenderer(
  isDataPointInputControl,
  DataPointInputControl,
);

export const dataSourceEnumControlRenderer = createPrimitiveControlRenderer(
  isDataSourceEnumControl,
  DataSourceEnumControl,
);

export const generatedIdControlRenderer = createPrimitiveControlRenderer(
  isGeneratedIdControl,
  GeneratedIdControl,
);

export const imageFileControlRenderer = createPrimitiveControlRenderer(
  isAssetFileControl,
  AssetFileControl,
);

/**
 * Object Controls
 */
export const objectControlRenderer = createRenderer(
  isObjectDispatchControl,
  ObjectControl,
  'object',
);

export const objectCardRenderer = createRenderer(
  isObjectCard,
  ObjectCard,
  'object',
);

export const conditionalActionControlRenderer = createRenderer(
  isConditionalActionControl,
  ConditionalActionControl,
  'object',
);

/**
 * Array Controls
 */

export const arrayComplexObjectControlRenderer = createRenderer(
  isArrayObjectComplexDispatchControl,
  ArrayOfComplexObjectsControl,
  'array',
  true,
);

export const arrayPrimitiveObjectControlRenderer = createRenderer(
  isArrayObjectPrimitiveDispatchControl,
  ArrayOfPrimitiveObjectsControl,
  'array',
  true,
);

export const checkboxGroupControlRenderer = createRenderer(
  isCheckboxGroupControl,
  CheckboxGroupControl,
  'array',
  true,
);

export const arrayPrimitiveControlRenderer = createRenderer(
  isArrayPrimitiveDispatchControl,
  ArrayPrimitiveControl,
  'array',
  true,
);

export const arrayJsonLogicControlRenderer = createRenderer(
  isJsonLogicArrayControl,
  ArrayJsonLogicControl,
  'array',
  true,
);

/**
 * Entity reference controls
 */

export const entityReferenceStringControlRenderer =
  createPrimitiveControlRenderer(
    isEntityReferenceStringControl,
    EntitySelectControl,
  );

export const entityReferenceObjectControlRenderer = createRenderer(
  isEntityReferenceInjectedControl,
  EntitySelectControl,
  'object',
);

export const arrayEntityReferenceControlRenderer = createRenderer(
  isArrayEntityReferenceControl,
  ArrayEntityReferenceControl,
  'array',
  true,
);

/**
 * Combinator Controls
 */

export const combinatorObjectInputControlOneOfRenderer = createRenderer(
  isCombinatorObjectInputControl,
  SelectableDiscriminatorCombinatorControl,
  'oneOf',
);

export const combinatorArrayInputControlOneOfRenderer = createRenderer(
  isCombinatorOneOfArrayInputControl,
  SelectableDiscriminatorCombinatorControl,
  'oneOf',
);

export const constantDiscriminatorCombinatorControlRenderer = createRenderer(
  isCombinatorArrayItemPageControl,
  ConstantDiscriminatorCombinatorControl,
  'oneOf',
);
